import React, { useCallback, useRef } from 'react';
import Toast from 'react-native-toast-notifications';

import { TaskCreatedToast } from '@components/TaskList/TaskCreatedToast.web';

export function useTaskToast() {
  const toastRef = useRef<Toast>(null);

  const showToast = useCallback(
    (title?: string, isFailedToast?: boolean) => {
      toastRef.current?.hideAll();

      const toastId = toastRef.current?.show(
        <TaskCreatedToast
          isFailedToast={isFailedToast ?? false}
          title={title ?? 'Operation Completed'}
          duration={3000}
          onPress={() => {
            setTimeout(() => {
              if (toastId) toastRef.current?.hide(toastId);
            }, 0);
          }}
        />,
        {
          type: 'custom',
          duration: 3000,
          placement: 'bottom',
          animationType: 'slide-in',
          style: {
            marginBottom: 39,
            backgroundColor: 'transparent',
            shadowColor: 'transparent',
          },
          onClose: () => {},
        }
      );
    },
    []
  );

  return {
    toastRef,
    showToast,
  };
}
